import { translations } from "@/lib/translations";

/**
 * English-only. Arabic, RTL, and the language switcher were removed — this hook
 * just exposes the English strings so existing `useLanguage()` call sites keep
 * working without a provider.
 */
export function useLanguage() {
  return {
    t: translations.en,
    language: "en" as const,
    dir: "ltr" as const,
  };
}
